import React from 'react';
import { useColorTheme } from '../../context/ColorThemeContext';

const CustomConfirmationModal = ({ 
  isOpen, 
  onClose, 
  onConfirm, 
  title, 
  message, 
  confirmText = "Confirm", 
  cancelText = "Cancel",
  type = "warning" // "success", "warning", "danger", "info"
}) => {
  const { colorTheme } = useColorTheme();
  
  if (!isOpen) return null;

  const getTypeColors = () => {
    switch (type) {
      case 'success':
        return {
          bg: colorTheme === 'purple' ? 'from-purple-400 to-purple-600' : colorTheme === 'blue' ? 'from-blue-400 to-blue-600' : 'from-green-400 to-green-600',
          button: colorTheme === 'purple' ? 'bg-purple-600 hover:bg-purple-700' : colorTheme === 'blue' ? 'bg-blue-600 hover:bg-blue-700' : 'bg-green-600 hover:bg-green-700',
          icon: '🎉',
          accent: colorTheme === 'purple' ? 'border-purple-500' : colorTheme === 'blue' ? 'border-blue-500' : 'border-green-500'
        };
      case 'warning':
        return {
          bg: 'from-yellow-400 to-orange-500',
          button: 'bg-orange-600 hover:bg-orange-700',
          icon: '⚠️',
          accent: 'border-orange-500'
        };
      case 'danger':
        return {
          bg: colorTheme === 'purple' ? 'from-pink-400 to-pink-600' : colorTheme === 'blue' ? 'from-red-400 to-red-600' : 'from-orange-400 to-orange-600',
          button: colorTheme === 'purple' ? 'bg-pink-600 hover:bg-pink-700' : colorTheme === 'blue' ? 'bg-red-600 hover:bg-red-700' : 'bg-orange-600 hover:bg-orange-700',
          icon: '🚨',
          accent: colorTheme === 'purple' ? 'border-pink-500' : colorTheme === 'blue' ? 'border-red-500' : 'border-orange-500'
        };
      case 'info':
      default:
        return {
          bg: 'from-blue-400 to-blue-600',
          button: 'bg-blue-600 hover:bg-blue-700',
          icon: 'ℹ️',
          accent: 'border-blue-500'
        };
    }
  };

  const colors = getTypeColors();

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-[60] p-4">
      <div className="bg-white dark:bg-gray-800 rounded-xl max-w-lg w-full shadow-2xl transform transition-all">
        {/* Header with gradient */}
        <div className={`bg-gradient-to-r ${colors.bg} p-6 rounded-t-xl`}>
          <div className="flex items-center">
            <span className="text-4xl mr-4">{colors.icon}</span>
            <div>
              <h3 className="text-xl font-bold text-white">{title}</h3>
            </div>
          </div>
        </div>

        {/* Content */}
        <div className="p-6">
          <div className={`border-l-4 ${colors.accent} bg-gray-50 dark:bg-gray-700 p-4 rounded-r-lg mb-6`}>
            <p className="text-gray-700 dark:text-gray-300 leading-relaxed whitespace-pre-line">
              {message}
            </p>
          </div>

          {/* Action Buttons */}
          <div className="flex items-center justify-end space-x-4">
            <button
              onClick={onClose}
              className="px-6 py-3 bg-gray-200 hover:bg-gray-300 dark:bg-gray-600 dark:hover:bg-gray-500 text-gray-700 dark:text-gray-300 rounded-lg font-medium transition-colors"
            >
              {cancelText}
            </button>
            <button
              onClick={onConfirm}
              className={`px-6 py-3 ${colors.button} text-white rounded-lg font-medium transition-colors shadow-lg hover:shadow-xl transform hover:scale-105 btn-ripple`}
            >
              {confirmText}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CustomConfirmationModal;